/**
 * Утилиты для работы с текстом и форматированием
 */

/**
 * Функция для правильного склонения слова "токен" в зависимости от числа
 * @param {number} count - Количество токенов
 * @returns {string} Правильно склоненное слово "токен"
 * 
 * @example
 * getBonusWord(1) // "токен"
 * getBonusWord(2) // "токена"
 * getBonusWord(5) // "токенов"
 * getBonusWord(21) // "токен"
 * getBonusWord(22) // "токена"
 */
export const getBonusWord = (count) => {
  const num = Math.floor(count);
  const lastDigit = num % 10;
  const lastTwoDigits = num % 100;
  
  // Исключения для 11-19
  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return 'токенов';
  }
  
  // 1, 21, 31, 41... → "токен"
  if (lastDigit === 1) {
    return 'токен';
  }
  
  // 2, 3, 4, 22, 23, 24... → "токена"
  if (lastDigit >= 2 && lastDigit <= 4) {
    return 'токена';
  }
  
  // Остальные → "токенов"
  return 'токенов';
};

/** Подпись цены на карточке. Речь считается по длине текста, на карточке — минимум. */
export const formatModelTokenPrice = (model) => {
  const amount = Number(model?.cost_in_bonuses);
  const safe = Number.isFinite(amount) ? amount : 0;
  const label = `${safe} ${getBonusWord(safe)}`;
  if (model?.category === 'speech_generation') {
    return `от ${label}`;
  }
  return label;
};
